<!--
 * @Author: 通用列表容器
 * @Date: 2020-07-27 15:04:12
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-27 16:16:16
 * @FilePath: \car-demo\src\components\List.vue
-->

<template>
	<div class="ml-14 mr-14">
		<nut-row
			v-if="title"
			type="flex"
			justify="space-between"
			class="title-section"
		>
			<b class="title">{{ title }}</b>
			<span class="extra" @click="handleClickMore"
				>查看更多
				<svg
					t="1595833160218"
					class="icon"
					viewBox="0 0 1024 1024"
					version="1.1"
					xmlns="http://www.w3.org/2000/svg"
					p-id="2115"
					width="12"
					height="10"
				>
					<path
						d="M877.216 491.808M297.952 949.984c-12.512-12.512-13.248-31.872-2.048-43.776l376.48-376.512c16.16-15.328 16.096-19.328 0-35.424L295.904 117.824C284.672 105.92 285.44 86.56 297.952 74.048c12.736-12.736 32.608-13.44 44.448-1.632l418.176 418.176c5.152 5.152 7.456 11.84 7.872 18.784l0 5.248c-0.448 6.944-2.752 13.632-7.872 18.784L342.4 951.616C330.56 963.392 310.656 962.688 297.952 949.984z"
						p-id="2116"
						data-spm-anchor-id="a313x.7781069.0.i0"
						class="selected"
						fill="#999999"
					></path></svg
			></span>
		</nut-row>
		<div class="list">
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'list',
	props: {
		// type: {
		//     default: 'default',
		//     type: String,
		// },
		title: String,
	},
	methods: {
		handleClickMore() {
			this.$emit('more')
		}
	}
}
</script>

<style></style>
